<!-- 申诉详情 -->
<template>
    <div class="appealDetail">
        <div class="guide-block"></div>
        <div class="appealDetail-container">
            <div v-if="obj.type == 1">
                <div class="title">投诉反馈</div>
                <div class="text">投诉内容：{{ data.appealContent }}</div>
                <div class="nodeList">
                    <div class="node" v-for="(item, index) in nodeList" :key="index">
                        <div class="node-left">
                            <div v-if="index != nodeList.length - 1 || data.status == 1" class="big-circle">
                                <div class="circle"></div>
                            </div>

                            <div v-if="index != nodeList.length - 1" class="line"></div>
                            <div v-if="data.status == 2 && index == nodeList.length - 1" class="success">
                                <img src="@/assets/images/operationGuide/success.png" alt="" />
                            </div>
                        </div>
                        <div class="node-right">
                            <div class="node-right-title">{{ item.nodeName }}</div>
                            <div class="node-right-content">{{ item.nodeContent }}</div>
                            <div class="node-right-date">{{ item.date }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="obj.type == 2">
                <div class="title">
                    <span v-if="data.type == 1">车牌认证</span>
                    <span v-if="data.type == 2">关于停车</span>
                    <span v-if="data.type == 3">关于充值</span>
                    <span v-if="data.type == 4">关于缴费</span>
                    <span v-if="data.type == 5">其他</span>
                </div>
                <div class="text">问题建议： {{ data.complaintContent ? data.complaintContent : "空" }}</div>
                <div v-if="data.frontComplaintPic" class="imgList">
                    <vant-image class="img" v-if="data.frontComplaintPic" fit="cover" width="100" height="100" :src="data.frontComplaintPic" />
                    <vant-image class="img" v-if="data.postComplaintPic" fit="cover" width="100" height="100" :src="data.postComplaintPic" />
                </div>
                <div class="nodeList">
                    <div class="node" v-for="(item, index) in nodeList" :key="index">
                        <div class="node-left">
                            <div v-if="index != nodeList.length - 1 || data.status == 1" class="big-circle">
                                <div class="circle"></div>
                            </div>

                            <div v-if="index != nodeList.length - 1" class="line"></div>
                            <div v-if="data.status == 2 && index == nodeList.length - 1" class="success">
                                <img src="@/assets/images/operationGuide/success.png" alt="" />
                            </div>
                        </div>
                        <div class="node-right">
                            <div class="node-right-title">{{ item.nodeName }}</div>
                            <div class="node-right-content">{{ item.nodeContent }}</div>
                            <div class="node-right-date">{{ item.date }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { msgDetail } from "@/api/api";
import { Image } from "vant";
export default {
    name: "orderAppealDetail",
    components: { "vant-image": Image },

    data() {
        return {
            obj: {},
            data: {},
            nodeList: [
                {
                    id: 1,
                    nodeName: "已提交申诉",
                    nodeContent: "",
                    date: "07月30日 15:31",
                },
                { id: 2, nodeName: "处理中", nodeContent: "你的投诉我们回尽快核实处理，后续将通知你。处理结果，请耐心等待。", date: "07月30日 15:31" },
                //{ id: 3, nodeName: "处理完成", nodeContent: "asdasdas", date: "07月30日 15:31" },
            ],
        };
    },
    mounted() {
        this.obj = this.$route.query;

        msgDetail(this.obj).then((res) => {
            console.log(res);
            if (res.code == 200) {
                this.data = res.data;
                //处理数据
                if (this.obj.type == 1) {
                    this.nodeList[0].nodeContent = this.data.appealContent;
                    this.nodeList[0].date = this.data.appealTimeStr;

                    this.nodeList[1].date = this.data.appealTimeStr;

                    if (this.data.status == 2) {
                        let obj = {
                            nodeName: "处理完成",
                            nodeContent: this.data.handleContent,
                            date: this.data.handleTimeStr,
                        };
                        this.nodeList.push(obj);
                    }
                } else if (this.obj.type == 2) {
                    this.nodeList[0].nodeContent = this.data.complaintContent;
                    this.nodeList[0].date = this.data.complaintTimeStr;

                    this.nodeList[1].date = this.data.complaintTimeStr;

                    if (this.data.status == 2) {
                        let obj = {
                            nodeName: "处理完成",
                            nodeContent: this.data.handleContent,
                            date: this.data.handleTimeStr,
                        };
                        this.nodeList.push(obj);
                    }
                }
            }
        });
    },

    methods: {},
};
</script>
<style lang="less" scoped>
* {
    font-family: PingFang SC;
}
.guide-block {
    height: 16px;
}
.appealDetail {
    .appealDetail-container {
        padding: 32px;
        min-height: 1318px;
        width: 100%;
        background-color: #fff;
        .title {
            font-size: 32px;
            color: #333;
            font-weight: 400;
            margin-bottom: 17px;
        }
        .text {
            font-size: 24px;
            color: #666;
            word-wrap: break-word;
        }
        .imgList {
            margin-top: 20px;
            .img {
                margin-right: 10px;
            }
        }
    }
}

.nodeList {
    min-height: 600px;
    width: 100%;
    margin: 32px 0;
    // padding-left: 20px;
    .node {
        display: flex;
        min-height: 200px;
    }
    .node-left {
        margin-right: 17px;
        width: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .big-circle {
            margin-top: 5px;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 4px #fff solid;
        }
        .circle {
            height: 12px;
            width: 12px;
            border-radius: 50%;
            border: 0.5px #009af3 solid;
            background-clip: padding-box;
        }
        .success {
            border: 5px #fff solid;
            border-radius: 50%;
            img {
                height: 32px;
                width: 32px;
            }
        }

        .line {
            height: ~"calc(100% - 30px)";
            width: 0.5px;
            border-left: 0.5px #009af3 solid;
        }
    }
    .node-right {
        width: 686px;
        .node-right-title {
            color: #009af3;
            font-size: 28px;
            font-weight: 400;
        }
        .node-right-content {
            min-height: 64px;
            margin: 16px 0px;
            background-color: #f5f5f5;
            color: #666666;
            font-size: 28px;
            font-weight: 400;
            padding: 9px 13px;
        }
        .node-right-date {
            font-size: 24px;
            color: #999999;
        }
    }
}
</style>
